import { ContainerModule } from 'inversify';

import { MonitoringService } from './monitoring.service';
import { IMonitoringService, TYPES } from './monitoring.types';

export const monitoringModule = new ContainerModule((bind) => {
  bind<IMonitoringService>(TYPES.MonitoringService).toDynamicValue(() =>
    MonitoringService.getInstance()
  );
});
